import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { GenericStoreBootstrapModule } from './lib/generic-store.bootstrap.module';
export { StoreProductOverviewComponent } from './lib/components/store-product-overview/store-product-overview.component';
export { StoreReceiptComponent } from './lib/components/store-receipt/store-receipt.component';

const loadChildren = () =>
  import('./lib/generic-store.lazy.module').then(
    (module) => module.GenericStoreLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const genericStoreLazyImports: ComponentNameAndModule[] = [
  defineImport('StoreProductOverview'),
  defineImport('StoreReceipt'),
];

export { genericStoreLazyImports, GenericStoreBootstrapModule };
